import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { sociallinkComponent } from './sociallink/sociallink.component';

@NgModule({
  declarations: [
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    sociallinkComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    RouterModule
  ],
  providers: [
  ]
})
export class LayoutModule { }
